<script setup lang="ts">
import { warningFormMessage } from '../FormFooterForm/data'

const showAnimation = ref(true)

setTimeout(() => {
    showAnimation.value = false
}, 900)
</script>

<template>
    <div>
        <span class="relative ml-[22px] mt-9 flex size-14">
            <span
                v-if="showAnimation"
                class="absolute inline-flex size-full animate-ping rounded-full bg-plus-lp-danger opacity-75"
            />
            <div class="mb-2 inline-flex size-14 items-center justify-center rounded-full bg-plus-lp-danger">
                <img
                    src="https://api.plus.pl/file/images_lp/plus_acse_landingpages/Footer/Warning.webp"
                    alt="Warning"
                    class="invert"
                />
            </div>
        </span>
        <h3 class="lp-heading-sm mb-2 mt-10 font-bold leading-7 text-plus-lp-dark-blue xl:lp-heading-lg">
            {{ warningFormMessage.title }}
        </h3>
        <span class="lp-label-md text-plus-lp-dark-blue-400">{{ warningFormMessage.subtitle }}</span>
        <PlusBlogLpAtomBaseButton
            variant="primary"
            arrow
            class="ml-auto mt-6"
            @click="$emit('retryForm')"
        >
            Spróbuj ponownie
        </PlusBlogLpAtomBaseButton>
    </div>
</template>
